import { Box, Button, Stack, TextField } from '@mui/material';
import { IHeader } from 'components/Header';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from 'components/Header/Header';
import AddIcon from '@mui/icons-material/Add';
import { ReferenceTable } from './ReferenceTable/ReferenceTable';
import { IReferenceProps } from './IReference';
import { searchReference, deleteReferenceById } from 'actions/LaboratoryActions';
import { IReducer } from 'Reducers/IReducer';
import { bindActionCreators } from 'redux';
import { useEffect, useState } from 'react';
import { DeleteDialog } from 'components/DeleteDialog';
import { IReference } from 'exactt-types/lib';
import Pagination from '@mui/material/Pagination';

function _Reference(props: IReferenceProps) {
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [selectedReference, setSelectedReference] = useState<undefined | IReference>(undefined);
  const [searchQuery, setSearchQuery] = useState('');

  // pagination
  const [page, setPage] = useState(1);
  const size = 15;

  const laboratoryID = props.laboratory?.details._id || '';

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
    props.searchReference(laboratoryID, { page: value, size: size, query: searchQuery });
  };

  const breadcrumbsList: IHeader['breadcrumbsList'] = [
    {
      label: 'Dashboard',
      onClick: () => navigate('/'),
    },
    {
      label: 'Reference',
      onClick: () => navigate('/laboratory/references'),
    },
  ];

  const onFocus = async () => {
    await props.searchReference(laboratoryID, { page: page, size: size, query: searchQuery });
  };

  const handleDeleteReference = () => {
    try {
      setDeleteLoading(true);
      props.deleteReferenceById(laboratoryID, selectedReference?._id || '');
      setDeleteModal(false);
    } catch (err) {
      console.log(err);
    } finally {
      setDeleteLoading(false);
      onFocus();
    }
  };

  useEffect(() => {
    props.searchReference(laboratoryID, { page: page, size: size, query: searchQuery });
    // eslint-disable-next-line
  }, [searchQuery]);

  return (
    <Box>
      <Header
        breadcrumbsList={breadcrumbsList}
        title="reference"
        right={
          <Box display={'flex'} alignItems={'center'} gap={2}>
            <TextField
              label={'Search'}
              size={'small'}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Button
              variant={'contained'}
              startIcon={<AddIcon />}
              onClick={() => navigate('/laboratory/references/persist')}
            >
              Add Reference
            </Button>
          </Box>
        }
      />
      <Box p={2} pt={10}>
        <ReferenceTable
          data={props.reference || []}
          onDelete={(reference) => {
            setDeleteModal(true);
            setSelectedReference(reference);
          }}
          onEdit={(reference) => {
            navigate(`/laboratory/references/persist?id=${reference._id}`);
          }}
        />
      </Box>
      <DeleteDialog
        title="Delete Reference"
        message={`Are you sure you want to remove ${selectedReference?.name} reference?`}
        isVisible={deleteModal}
        onClose={() => setDeleteModal(false)}
        onAction={() => handleDeleteReference()}
        isLoading={deleteLoading}
      />

      <Stack spacing={2}>
        <Pagination count={props.count} shape="rounded" page={page} onChange={handlePageChange} defaultPage={page} />
      </Stack>
    </Box>
  );
}

const mapStateToProps = (state: IReducer) => {
  return {
    laboratory: state.laboratory.current,
    reference: state.laboratory.reference,
    count: state.laboratory.count.reference,
  };
};

function mapDispatchToProps(dispatch: any) {
  return {
    ...bindActionCreators({ searchReference, deleteReferenceById }, dispatch),
  };
}

export const Reference = connect(mapStateToProps, mapDispatchToProps)(_Reference);
